export default __webpack_public_path__ + "static/media/chairPoster.b8b2bf7a.svg";